import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { useNavigate } from 'react-router';
import QRScannerDialog from './QRScannerDialog';
import LogoutIcon from '@mui/icons-material/Logout';

import {
  AppBar,
  Badge,
  Box,
  IconButton,
  Toolbar,
  Menu,
  Typography,
  Chip,
  Avatar,
  Button,
  Drawer,
  TextField,
  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';
// Dropdown Component
import CartDropdown from './CartDropdown';
import MessageDropdown from './MessageDropdown';
import NotificationDropdown from './NotificationDropdown';
import ProfileDropdown from './ProfileDropdown';
import CustomTextField from '../../../components/forms/custom-elements/CustomTextField';
import userimg from '../../../assets/images/users/3.jpg';
import { set } from 'lodash';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CmdFbDetailsWidget from '../../../features/commande-fournisseur/CmdFbDetails.widget.js';

const Header = ({
  sx,
  customClass,
  toggleSidebar,
  toggleMobileSidebar,
  loggedUser,
  switch_mg,
  lst_mg,
  onSelectMg,
  mg_config,
}) => {
  const navigate = useNavigate();
  const [showScanner, setShowScanner] = useState(false);

  const handleScan = (data) => {
    setShowScanner(false);
    try {
      const parsed = JSON.parse(data);
      if (parsed?.type && parsed?.id) {
        switch (parsed.type) {
          case 'bon-commande':
            //navigate(`/app/achat/${parsed.id}`);
            set_show_cmd_details(true);
            set_sel_cmd(parsed.id);
            break;
          case 'doc-diamant':
            navigate(`/app/stock-diamant/doc/details/${parsed.id}`);
            break;
          case 'mvm-diamant':
            navigate(`/app/stock-diamant-fb/mvm/details/${parsed.id}`);
            break;
          default:
            console.warn('Unknown QR code type:', parsed.type);
            alert('Type de QR code inconnu : ' + parsed.type);
        }
      } else {
        alert('Format de QR code invalide');
      }
    } catch (e) {
      console.error('Error parsing QR code:', e);
      alert('Erreur lors de la lecture du QR code');
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sel_mg, set_sel_mg] = useState(null);
  const [sel_mg_key, set_sel_mg_key] = useState(`sel-mg-${new Date().getTime()}`);
  const [show_cmd_details, set_show_cmd_details] = useState(false);
  const [sel_cmd, set_sel_cmd] = useState(null);

  const onCloseCmdDetails = () => {
    set_show_cmd_details(false);
    set_sel_cmd(null);
  };

  const onSubmitMg = (value) => {
    set_sel_mg(value);
    onSelectMg(lst_mg.find((el) => el?.idMagasin == value));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  // 2
  const [anchorEl2, setAnchorEl2] = React.useState(null);

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  // 4
  const [anchorEl4, setAnchorEl4] = React.useState(null);

  const handleClick4 = (event) => {
    setAnchorEl4(event.currentTarget);
  };

  const handleClose4 = () => {
    setAnchorEl4(null);
  };

  // drawer
  const [showDrawer, setShowDrawer] = useState(false);

  const handleDrawerClose = () => {
    setShowDrawer(false);
  };

  // drawer top
  const [showDrawer2, setShowDrawer2] = useState(false);

  const handleDrawerClose2 = () => {
    setShowDrawer2(false);
  };

  useEffect(() => {
    if (mg_config && Array.isArray(lst_mg)) {
      set_sel_mg(mg_config?.idMagasin);
      set_sel_mg_key(`sel-mg-${new Date().getTime()}`);
    }
  }, [mg_config]);

  return (
    <AppBar sx={sx} elevation={0} className={customClass}>
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleSidebar}
          size="large"
          sx={{
            display: {
              lg: 'flex',
              xs: 'none',
            },
          }}
        >
          <FeatherIcon icon="menu" />
        </IconButton>
        <IconButton
          size="large"
          color="inherit"
          aria-label="menu"
          onClick={toggleMobileSidebar}
          sx={{
            display: {
              lg: 'none',
              xs: 'flex',
            },
          }}
        >
          <FeatherIcon icon="menu" width="20" height="20" />
        </IconButton>
        {/* ------------------------------------------- */}
        {/* Search Dropdown */}
        {/* ------------------------------------------- */}
        {switch_mg ? (
          <TextField
            key={sel_mg_key}
            select
            size="small"
            placeholder="Search"
            sx={{ padding: '0px !important', width: 160, borderColor: '#159073 !important', backgroundColor : 'rgba(27, 131, 172, 0.07)' }}
            value={sel_mg}
            onChange={(e) => onSubmitMg(e?.target?.value)}
          >
            <MenuItem value="all">Global</MenuItem>
            {lst_mg.map((item, index) => (
              <MenuItem key={`sw-mg-${index}`} value={item.idMagasin}>
                {item.code}
              </MenuItem>
            ))}
          </TextField>
        ) : loggedUser?.role !== 'fournisseur' ? (
          <Chip
            size="small"
            sx={{
              padding: '6px',
              width: 160,
              borderRadius: 1,
              bgcolor: mg_config?.bg_color,
              color: '#fff',
            }}
            label={mg_config?.nom}
          />
        ) : (
          <></>
        )}

        {/* ------------------------------------------- */}
        {/* scan button */}
        {/* ------------------------------------------- */}

        {loggedUser?.role !== 'fournisseur' && (
          <>
            <StorefrontIcon
              fontSize="small"
              sx={{ ml: switch_mg ? '-50px' : '-30px', color: '#279073' }}
            />
            {/* Scanner Button */}
            <Button
              color="inherit"
              variant='outlined'
              onClick={() => setShowScanner(true)}
              sx={{ ml: 1, color: 'white', textTransform: 'none', marginLeft: '60px', borderColor: '#1b83ac', backgroundColor : 'rgba(27, 131, 172, 0.07)'  }}
              startIcon={<QrCodeScannerIcon />}
            >
              Scanner
            </Button>
          </>
        )}


        <QRScannerDialog
          open={showScanner}
          onClose={() => setShowScanner(false)}
          onScan={handleScan}
        />

        <CmdFbDetailsWidget
          idCmdFournisseur={sel_cmd}
          show={show_cmd_details}
          onClose={onCloseCmdDetails}
        />

        <Drawer
          anchor="top"
          open={showDrawer2}
          onClose={() => setShowDrawer2(false)}
          sx={{
            '& .MuiDrawer-paper': {
              padding: '15px 30px',
            },
          }}
        >
          <Box display="flex" alignItems="center">
            <CustomTextField
              id="tb-search"
              size="small"
              placeholder="Search here"
              fullWidth
              inputProps={{ 'aria-label': 'Search here' }}
            />
            <Box
              sx={{
                ml: 'auto',
              }}
            >
              <IconButton
                color="inherit"
                sx={{
                  color: (theme) => theme.palette.grey.A200,
                }}
                onClick={handleDrawerClose2}
              >
                <FeatherIcon icon="x-circle" />
              </IconButton>
            </Box>
          </Box>
        </Drawer>
        {/* ------------ End Menu icon ------------- */}
        <Box flexGrow={1} />
        {/* ------------------------------------------- */}
        {/* Ecommerce Dropdown */}
        {/* ------------------------------------------- */}
        {/* <IconButton size="large" color="inherit" onClick={() => setShowDrawer(true)}>
          <FeatherIcon icon="shopping-cart" width="20" height="20" />
        </IconButton> */}
        <Drawer
          anchor="right"
          open={showDrawer}
          onClose={() => setShowDrawer(false)}
          sx={{
            '& .MuiDrawer-paper': {
              width: {
                xs: '100%',
                sm: '395px',
              },
              padding: '30px',
            },
          }}
        >
          <Box display="flex" alignItems="center">
            <Typography variant="h4" fontWeight="500">
              Shopping Cart
            </Typography>
            <Box
              sx={{
                ml: 'auto',
              }}
            >
              <IconButton
                color="inherit"
                sx={{
                  color: (theme) => theme.palette.grey.A200,
                }}
                onClick={handleDrawerClose}
              >
                <FeatherIcon icon="x-circle" />
              </IconButton>
            </Box>
          </Box>

          {/* component */}
          <CartDropdown />
        </Drawer>
        {/* ------------------------------------------- */}
        {/* End Ecommerce Dropdown */}
        {/* ------------------------------------------- */}
        {/* ------------------------------------------- */}
        {/* Messages Dropdown */}
        {/* ------------------------------------------- */}
        {/* <IconButton
          size="large"
          aria-label="show 11 new notifications"
          color="inherit"
          aria-controls="msgs-menu"
          aria-haspopup="true"
          onClick={handleClick2}
        >
          <Badge variant="dot" color="primary">
            <FeatherIcon icon="message-square" width="20" height="20" />
          </Badge>
        </IconButton>
        <Menu
          id="msgs-menu"
          anchorEl={anchorEl2}
          keepMounted
          open={Boolean(anchorEl2)}
          onClose={handleClose2}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          sx={{
            '& .MuiMenu-paper': {
              width: '385px',
              right: 0,
              top: '70px !important',
            },
            '& .MuiList-padding': {
              p: '30px',
            },
          }}
        >
          <Box
            sx={{
              mb: 1,
            }}
          >
            <Box display="flex" alignItems="center">
              <Typography variant="h4" fontWeight="500">
                Messages
              </Typography>
              <Box
                sx={{
                  ml: 2,
                }}
              >
                <Chip
                  size="small"
                  label="5 new"
                  sx={{
                    borderRadius: '6px',
                    pl: '5px',
                    pr: '5px',
                    backgroundColor: (theme) => theme.palette.secondary.main,
                    color: '#fff',
                  }}
                />
              </Box>
            </Box>
          </Box>
          <MessageDropdown />

          <Button
            sx={{
              mt: 2,
              display: 'block',
              width: '100%',
            }}
            variant="contained"
            color="primary"
            onClick={handleClose2}
          >
            <Link
              to="/email"
              style={{
                color: '#fff',
                width: '100%',
                display: 'block',
                textDecoration: 'none',
              }}
            >
              See all messages
            </Link>
          </Button>
        </Menu> */}
        {/* ------------------------------------------- */}
        {/* End Messages Dropdown */}
        {/* ------------------------------------------- */}
        {/* ------------------------------------------- */}
        {/* Notifications Dropdown */}
        {/* ------------------------------------------- */}
        {/* <IconButton
          size="large"
          aria-label="menu"
          color="inherit"
          aria-controls="notification-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <Badge variant="dot" color="secondary">
            <FeatherIcon icon="bell" width="20" height="20" />
          </Badge>
        </IconButton>
        <Menu
          id="notification-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          sx={{
            '& .MuiMenu-paper': {
              width: '385px',
              right: 0,
              top: '70px !important',
            },
            '& .MuiList-padding': {
              p: '30px',
            },
          }}
        >
          <Box
            sx={{
              mb: 1,
            }}
          >
            <Box display="flex" alignItems="center">
              <Typography variant="h4" fontWeight="500">
                Notifications
              </Typography>
              <Box
                sx={{
                  ml: 2,
                }}
              >
                <Chip
                  size="small"
                  label="5 new"
                  sx={{
                    borderRadius: '6px',
                    pl: '5px',
                    pr: '5px',
                    backgroundColor: (theme) => theme.palette.warning.main,
                    color: '#fff',
                  }}
                />
              </Box>
            </Box>
          </Box>
          <NotificationDropdown />
          <Button
            sx={{
              mt: 2,
              display: 'block',
              width: '100%',
            }}
            variant="contained"
            color="primary"
            onClick={handleClose}
          >
            <Link
              to="/email"
              style={{
                color: '#fff',
                width: '100%',
                display: 'block',
                textDecoration: 'none',
              }}
            >
              See all notifications
            </Link>
          </Button>
        </Menu> */}
        {/* ------------------------------------------- */}
        {/* End Notifications Dropdown */}
        {/* ------------------------------------------- */}
        <Link
            style={{
              textDecoration: 'none',
            }}
            to="/"
          >
        <Button
              color="inherit"
              variant='outlined'
              onClick={() => setShowScanner(true)}
              sx={{ ml: 1, color: 'white', textTransform: 'none', marginLeft: '60px', borderColor: '#a0193d', backgroundColor : '#a0193d19'  }}
              startIcon={<LogoutIcon />}
            >
              Se déconnecter
            </Button>
            </Link>
        <Box
          sx={{
            width: '1px',
            backgroundColor: 'rgba(0,0,0,0.1)',
            height: '25px',
            ml: 1,
            mr: 1,
          }}
        />
        {/* ------------------------------------------- */}
        {/* Profile Dropdown */}
        {/* ------------------------------------------- */}
        {/* <Button
          aria-label="menu"
          color="inherit"
          aria-controls="profile-menu"
          aria-haspopup="true"
          onClick={handleClick4}
        >
          <Box display="flex" alignItems="center">
            <Avatar
              sx={{
                width: '32px',
                height: '32px',
              }}
            >
              {String(loggedUser?.nom).charAt(0).toUpperCase() +
                String(loggedUser?.prenom).charAt(0).toUpperCase()}
            </Avatar>
            <Box
              sx={{
                display: {
                  xs: 'none',
                  sm: 'flex',
                },
                alignItems: 'center',
              }}
            >
              <Typography color="textSecondary" variant="h5" fontWeight="400" sx={{ ml: 1 }}>
                Hi,
              </Typography>
              <Typography
                variant="h5"
                fontWeight="700"
                sx={{
                  ml: 1,
                  textTransform: 'capitalize',
                }}
              >
                {loggedUser?.nom}
              </Typography>
              <FeatherIcon icon="chevron-down" width="20" height="20" />
            </Box>
          </Box>
        </Button>
        <Menu
          id="profile-menu"
          anchorEl={anchorEl4}
          keepMounted
          open={Boolean(anchorEl4)}
          onClose={handleClose4}
          sx={{
            '& .MuiMenu-paper': {
              width: '385px',
              right: 0,
              top: '70px !important',
            },
            '& .MuiList-padding': {
              p: '30px',
            },
          }}
        >
          <ProfileDropdown loggedUser={loggedUser} />
          <Link
            style={{
              textDecoration: 'none',
            }}
            to="/"
          >
            <Button
              sx={{
                mt: 2,
                display: 'block',
                width: '100%',
              }}
              variant="contained"
              color="error"
            >
              Logout
            </Button>
          </Link>
        </Menu> */}
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  sx: PropTypes.object,
  customClass: PropTypes.string,
  toggleSidebar: PropTypes.func,
  toggleMobileSidebar: PropTypes.func,
};

export default Header;
